export function Skeleton({ className = "" }: { className?: string }) {
  return (
    <div
      className={`rounded-md overflow-hidden ${className}`.trim()}
      aria-hidden
      style={{
        background: `linear-gradient(90deg, var(--color-muted) 0%, color-mix(in oklab, var(--color-muted) 70%, white) 50%, var(--color-muted) 100%)`,
        backgroundSize: "200% 100%",
        animation: "skeleton-shimmer 1.8s ease-in-out infinite",
      }}
    />
  );
}
